module.exports = __webpack_public_path__ + "img/ichiran_btn.51782921.png";